import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Resolve a reference's URL/DOI into something openable. DOIs (e.g. 10.1000/xyz)
// go through doi.org; bare domains get an https:// prefix; full URLs pass through.
const resolveHref = (raw) => {
  const value = (raw || '').trim();
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  if (/^10\.\d{4,}\//.test(value)) return `https://doi.org/${value}`;
  return `https://${value}`;
};

// Read-only view of a reference. Shown to everyone (including members) when a
// reference row is clicked. Editing happens via the 3-dot menu, not here.
const ViewReferenceModal = ({ open, handleClose, item }) => {
  const href = resolveHref(item?.url);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontSize: '26px', fontWeight: 700, textAlign: 'left' }}>
        Reference Item
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 18, top: 18, color: '#000' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'left', color: '#000' }}>
        <p style={{ fontSize: '18px', lineHeight: 1.4, marginTop: 0, marginBottom: '16px' }}>
          {item?.reference}
        </p>

        {href && (
          <p style={{ marginTop: 0, marginBottom: '20px' }}>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1976d2', textDecoration: 'underline' }}
            >
              Linked Resource
            </a>
          </p>
        )}

        <p style={{ fontWeight: 700, marginBottom: '6px' }}>Reference Notes</p>
        <p style={{ marginTop: 0, whiteSpace: 'pre-wrap' }}>{item?.notes}</p>
      </DialogContent>
    </Dialog>
  );
};

export default ViewReferenceModal;
